import React from 'react';
import LandingLayout from '../../../components/Layout/LandingLayout';
import LandingTerms from '../../../components/LandingLegal/LandingTerms';
import messages from '../../../locale/messages';
import getLandingMessage from '../../landing/getLandingMessage';

export default async function action({ store }) {
  return {
    title: getLandingMessage(store, messages.batch2PrivacyMetaTitle),
    description: getLandingMessage(store, messages.batch2PrivacyMetaDescription),
    chunk: 'privacy',
    component: (
      <LandingLayout>
        <LandingTerms pageTitleMessage={messages.batch2PrivacyH1} />
      </LandingLayout>
    ),
  };
};
